module.exports = __webpack_public_path__ + "media/images/sand-clock-ec7a64ac94d1196ccade89f58f6a5a4e.svg";